var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"admin-dashboard"}},[_c('admin-navigation',{attrs:{"drawer":_vm.drawer}}),_c('admin-toolbar',{on:{"setDrawer":_vm.setDrawer}}),_c('v-content',[_c('router-view',{attrs:{"user":_vm.user}})],1),_c('admin-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }